export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8934.1e0ebb24.jpg";